import Cookies from "js-cookie";
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示

const Auth = {
  // 檢查是否已登入，並導航到登入頁面
  checkLogin(router) {
    const token = Cookies.get("token");
    const allowedPaths = ["/", "/login", "/forgot", "/reset"]; // 定義不需要檢查登入狀態的頁面，檔/reset的主要原因--0110

    if (!token) {
      if (!allowedPaths.includes(router.currentRoute.path)) {
        // 檢查是否在允許的路徑內
        Swal.fire({
          icon: "warning",
          title: "未登入",
          text: "請重新登入！",
          confirmButtonText: "確定",
        });
        router.push("/login").catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err); // 僅記錄非重複導航錯誤
          }
        });
      }
    } else {
      console.log("使用者已登入");
    }
  },

  // 登出功能
  logout(router) {
    Cookies.remove("token");
    Cookies.remove("email");
    Cookies.remove("role");
    Swal.fire({
      icon: "info", // 使用 info 圖示（登出非錯誤）
      title: "您已登出", // 更清楚的標題
      text: "請重新登入以繼續使用服務", // 更完整的說明
      confirmButtonText: "確定", // 按鈕文字
    }).then(() => {
      router.push("/login"); // ✅ 使用者按下確定後才導頁
    });
  },

  // 獲取當前用戶角色
  getRole() {
    const payload = this.getPayload();
    const role = payload?.role;
    return role != null ? parseInt(role, 10) : null;
  },

  getPayload() {
    const token = Cookies.get("token"); // 從 cookie 中取得 JWT token
    if (!token) return null;

    const payloadBase64 = token.split(".")[1]; // 取出 payload 區段
    try {
      const payloadJson = decodeURIComponent(
        atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"))
          .split("")
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join("")
      );
      return JSON.parse(payloadJson); // 回傳解析結果
    } catch (e) {
      console.error("JWT Payload 解析失敗：", e);
      return null;
    }
  },
  // 檢查角色是否符合權限
  hasPermission(requiredRole) {
    const currentRole = this.getRole();
    return currentRole === requiredRole;
  },

  // 根據角色跳轉頁面
  redirectToRolePage(router) {
    const role = this.getRole();
    console.log("解析到的角色：", role); // ✅ 加這行

    if (role === null) {
      Swal.fire({
        icon: "error",
        title: "未找到角色",
        text: "請重新登入！",
      }).then(() => {
        this.logout(router);
      });
      return;
    }

    const roleRoutes = {
      0: "/customer-dashboard",
      1: "/admin/dashboard",
    };

    const targetPath = roleRoutes[role];
    if (!targetPath) {
      Swal.fire({
        icon: "error",
        title: "未知角色",
        text: "請重新登入！",
      }).then(() => {
        this.logout(router);
      });
      return;
    }

    if (router.currentRoute.path !== targetPath) {
      router.push(targetPath);
    }
  },
};

export default {
  data() {
    return {
      isLoading: true, // 預設顯示載入畫面
      isMenuOpen: false, // 控制漢堡選單開關
    };
  },
  mounted() {

    setTimeout(() => {
      this.isLoading = false; // 4 秒後隱藏載入畫面
    }, 4000);
  },
  methods: {
    handleMemberClick() {
      const token = Cookies.get("token");

      if (!token) {
        Swal.fire({
          icon: "warning",
          title: "未登入",
          text: "請重新登入！",
          confirmButtonText: "確定",
        });
        this.$router.push("/login").catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error("導航錯誤：", err);
          }
        });
      } else {
        Auth.redirectToRolePage(this.$router); // 根據角色導航到對應頁面
      }
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // 切換選單狀態
    },

    handleLogout() {
      Auth.logout(this.$router); // 呼叫 Auth 的登出方法
    },
  },
};
